import React from 'react';
import { SyncingLine } from 'dig-components/dist/icons/src';
import { DebugPanel, PanelComponent } from './debug-panel';
import { useEventListener } from 'hellospa/common/hooks';
import { AppActionLogEntry } from 'hellospa/app-context';
import Table from 'hellospa/foundation/tables/table';
import { Button } from 'dig-components/dist/buttons';
import styles from './app-actions-panel.scss';


const copy = async (item: any) => {
  navigator.clipboard.writeText(JSON.stringify(item, null, 2));
};


const AppActionsPanel: PanelComponent = ({ isOpen }) => {
  const [log, setLog] = React.useState([] as AppActionLogEntry[]);
  useEventListener(document.body, 'app-action-log', (event) => {
    if (event instanceof CustomEvent) {
      const log: AppActionLogEntry[] = event.detail ?? [];
      setLog(log);
    }
  });

  if (!isOpen) {
    return null;
  }

  return (
    <React.Fragment>
      <DebugPanel.SectionHeader>
        AppActions

        <Button variant='outline' onClick={() => copy(log)}>
          Copy log
        </Button>
      </DebugPanel.SectionHeader>

      <Table currentPage={1}>
        <Table.Head className={styles.head}>
          <Table.Row>
            <Table.Heading>
              AppAction call
            </Table.Heading>
            <Table.Heading>
              Response
            </Table.Heading>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {log.map((item) => {
            return (
              <Table.Row key={item.id}>
                <Table.Data>
                  {item.timestamp}
                  <pre>
                    {item.name}(...{JSON.stringify(item.args, null, 2)})
                  </pre>
                </Table.Data>
                <Table.Data>
                  <pre>
                    {JSON.stringify(item.result, null, 2)}
                  </pre>
                </Table.Data>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </React.Fragment >
  );
};

export const appActionsPanel = (
  <DebugPanel
    Component={AppActionsPanel}
    icon={SyncingLine}
    title="App Actions" />
);
